import Swiper from 'swiper/bundle';
import '../../node_modules/swiper/swiper.min.css';
import '../../node_modules/swiper/modules/navigation/navigation.min.css';

export default class Slider {
  constructor({ el, options }) {
    // Elements
    this.el = el;
    this.swiper = null;

    // Setup
    this.options = options;
    this.create();
  }

  /**
   * Creates a new Swiper instance
   */
  create() {
    this.swiper = new Swiper(this.el, this.options);
  }

  /**
   * Initializes the Swiper instance
   * This is kept separate from the create process for components that need to
   * init and suspend/destroy multiple times.
   */
  init() {
    this.swiper.init();
  }

  /**
   * Destroys a Swiper instance without removing the instance, so that it can
   * be retreived by calling init again.
   */
  suspend() {
    this.swiper.destroy(false, false);
  }

  /**
   * Permanently destroy Swiper instance
   */
  destroy() {
    this.swiper.destroy();
  }

  /**
   * Unload
   */
  unload() {
    this.destroy();
  }
}